/* unplugin-vue-components disabled */import { render } from "./FooterMobile.vue?vue&type=template&id=2cf076d4&scoped=true"
import script from "./FooterMobile.vue?vue&type=script&lang=js"
export * from "./FooterMobile.vue?vue&type=script&lang=js"

import "./FooterMobile.vue?vue&type=style&index=0&id=2cf076d4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf076d4"]])

export default __exports__